import type { CSSProperties } from "react";
import "./cave-atmosphere.css";

/** Purely decorative layers; never receive input or obscure game controls. */
export function CaveAtmosphere({ welcome = false }: { welcome?: boolean }) {
  return (
    <div
      className={`cave-atmosphere${welcome ? " cave-atmosphere--welcome" : ""}`}
      aria-hidden="true"
    >
      {welcome ? (
        <picture>
          <source
            media="(max-width: 760px) and (max-aspect-ratio: 4/5)"
            srcSet="/assets/illustrations/welcome-mobile.webp"
          />
          <img
            className="cave-scene-art home-art"
            src="/assets/illustrations/welcome-desktop.webp"
            alt=""
            width={1672}
            height={941}
            fetchPriority="high"
          />
        </picture>
      ) : null}
      <div className="cave-lantern-glow" />
      <div className="cave-light-rays" />
      <div className="cave-dust">
        {Array.from({ length: 12 }, (_, index) => (
          <i
            key={index}
            style={
              {
                left: `${8 + ((index * 17) % 85)}%`,
                top: `${20 + ((index * 23) % 70)}%`,
                "--drift-time": `${12 + (index % 5) * 3}s`,
                "--drift-delay": `${-index * 2.7}s`,
              } as CSSProperties
            }
          />
        ))}
      </div>
    </div>
  );
}
